module.exports = __webpack_public_path__ + "static/media/rogue.3828649e.png";